import { Link } from 'react-router-dom';
import { footerLinks } from '../../../mocks/bbenergy';

export default function Footer() {
  return (
    <footer className="bg-[#071525] text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
          {/* Logo + About */}
          <div className="col-span-2 md:col-span-3 lg:col-span-2">
            <div className="flex items-center gap-2 mb-5">
              <span className="text-white font-bold text-lg tracking-wide">NRG Trading</span>
            </div>
            <p className="text-white/50 text-sm leading-relaxed max-w-xs mb-5">
              A global energy company — empowering people, nations, and businesses by responsibly trading and distributing energy worldwide.
            </p>

          </div>

          {/* Company */}
          <div>
            <p className="text-white text-xs font-bold tracking-widest uppercase mb-5">Company</p>
            <ul className="space-y-3">
              {footerLinks.company.map((link) => (
                <li key={link.label}>
                  <a href={link.href} className="text-white/50 text-sm hover:text-white transition-colors cursor-pointer">
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>


        </div>
      </div>

      {/* Legal Strip */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6">
          <div className="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-6 flex-wrap">
            <p className="text-white/30 text-xs whitespace-nowrap">
              &copy; {new Date().getFullYear()} NRG Trading. All rights reserved.
            </p>
            <div className="flex flex-wrap gap-x-5 gap-y-2">
              {footerLinks.legal.map((link) => (
                link.href.startsWith('/') ? (
                  <Link
                    key={link.label}
                    to={link.href}
                    className="text-white/30 text-xs hover:text-white/70 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                ) : (
                  <a
                    key={link.label}
                    href={link.href}
                    className="text-white/30 text-xs hover:text-white/70 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </a>
                )
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
